module.exports = __webpack_public_path__ + "static/media/ask-icn.cda05a28.svg";